import { render, staticRenderFns } from "./TemplateProductPodAssigner.vue?vue&type=template&id=b6f9b162"
import script from "./TemplateProductPodAssigner.vue?vue&type=script&lang=ts&setup=true"
export * from "./TemplateProductPodAssigner.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports